import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";

export const PATH_PAYMENT = "/payment";
export const PATH_PAYMENT_ADD_PAYMENT_METHOD = `${PATH_PAYMENT}/add-payment-method`;

export const PATH_PAYMENT_HISTORY = `${PATH_PAYMENT}/history`;
export const PARAMETER_PAYABLE_ID = "payableId";
export const PATH_PAYMENT_HISTORY_PAYABLE_DETAILS = `${PATH_PAYMENT_HISTORY}/:${PARAMETER_PAYABLE_ID}`;

export const routeHelpersClientPayableDetails = createRouteHelpers<{
  payableId: string;
}>(PATH_PAYMENT_HISTORY_PAYABLE_DETAILS);
